This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div>
    <div class="basicBlock">
      <p class="header upper">{{ $t("profile.userInfoBlockHeader") }}</p>
      <div class="data">
        <ul>
          <li class="blockEntry">
            {{ userInfo?.firstName }} {{ userInfo?.lastName }}
          </li>
          <li
            v-if="$te(`profile.permission.${userInfo.permissionLevel}`)"
            class="blockEntry"
          >
            {{ $t(`profile.permission.${userInfo.permissionLevel}`) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  data() {
    return {
      userInfo: null,
    };
  },
  beforeMount() {
    //Get user info
    this.userInfo = this.$store.getters.getUserInfo;
  },
})
export default class UserInfoBlock extends Vue {}
</script>
